import type React from 'react';
import styles from './Features.module.css';

const features = [
  {
    title: 'Easy to Use',
    description:
      'Our intuitive interface makes it easy for anyone to create stunning shaders.',
  },
  {
    title: 'Highly Customizable',
    description:
      'Customize every aspect of your shaders to match your brand and style.',
  },
  {
    title: 'Export Anywhere',
    description:
      'Export your shaders to use in any web project, with just a single line of code.',
  },
];

export const Features: React.FC = () => {
  return (
    <div className={styles.features}>
      <h2 className={styles.title}>Why Shadeables?</h2>
      <div className={styles.grid}>
        {features.map((feature) => (
          <div key={feature.title} className={styles.card}>
            <h3 className={styles.cardTitle}>{feature.title}</h3>
            <p className={styles.cardDescription}>{feature.description}</p>
          </div>
        ))}
      </div>
    </div>
  );
};
